import { IProtocol } from '@/pages/Equipment/equipment.types.ts'
import { useRecoilValue } from 'recoil'
import protocolsAtom from '@/pages/Equipment/atoms/protocols.atom.ts'
import { useMemo } from 'react'

const useEquipmentProtocol = (id: IProtocol['id']) => {
  const protocols = useRecoilValue(protocolsAtom).items

  return useMemo(() => {
    return protocols.find((p) => p.id === id)
  }, [protocols, id])
}

export default useEquipmentProtocol
